'use client';

import type { ContentfulEnvironmentOverride, SitePreviewData } from '../types';
import { getENV } from '../utils';
import { useCacheKey } from './useCacheKey';

const CONTENTFUL_ENVIRONMENT_OVERRIDES: ContentfulEnvironmentOverride[] = ['stage'];

function parsePreviewCookie(value: string): SitePreviewData | null {
    try {
        const parsed: unknown = JSON.parse(value);

        if (typeof parsed !== 'object' || parsed === null) {
            return null;
        }

        const obj = parsed as Record<string, unknown>;
        const result: SitePreviewData = {};

        if (typeof obj.previewDate === 'string') {
            result.previewDate = obj.previewDate;
        }

        if (
            getENV('NEXT_PUBLIC_APP_ENV') === 'stage' &&
            CONTENTFUL_ENVIRONMENT_OVERRIDES.includes(obj.contentfulEnvironment as ContentfulEnvironmentOverride)
        ) {
            result.contentfulEnvironment = obj.contentfulEnvironment as ContentfulEnvironmentOverride;
        }

        if (typeof obj.contentfulPreviewMode === 'boolean') {
            result.contentfulPreviewMode = obj.contentfulPreviewMode;
        }

        return result;
    } catch {
        return null;
    }
}

export function useSitePreviewData(): SitePreviewData | null {
    const { cookies } = useCacheKey();

    if (!getENV('NEXT_PUBLIC_SITE_PREVIEW')) return null;

    const raw = cookies.get('x-petm-preview');

    if (!raw) return null;

    return parsePreviewCookie(raw);
}
